/* eslint-disable */
import { TextField, Button, FormControlLabel, FormControl, RadioGroup, Radio, Autocomplete, Checkbox } from '@mui/material';
// ikony
import { ContentCopy as ContentCopyIcon } from '@mui/icons-material';
import { useEffect } from "react";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import { notificationStore } from "~/stores/notification";
import MyDialog from "~/mui/MyDialog";
import { getRestrictionType, checkForErrorsState, compareArray } from '~/utils/utils';
import { useTrans } from '~/hooks/useTrans';
import { apiUpdateKey, apiCreateKey, apiGetApiKeyServices, apiUpdateKeyServices } from '~/providers/api';
import { IClientKey, IRestrictions } from '~/providers/client-interfaces';
import { IUrlParams, IFetchOutput } from "~/interfaces";
import { MySwitch } from "~/mui/MySwitch";
import KeyRestrictionsEdit from "~/components/KeyRestrictionsEdit";
import { IAdminKey } from "~/providers/admin-interfaces";
import { KEY_DETAIL_LENGTH, MAX_INT_DESCIPTION_LEN, MAX_USER_DESCIPTION_LEN } from "~/const";
import { myUseState } from "~/hooks/myUseState";
import { useLang } from "~/hooks/useLang";
import { IServiceLittle } from "~/providers/interfaces";

import "./style.less";

type TRadioOpts = "all" | "selected";

interface IState {
	mainLoad: boolean;
	dialogLoading: boolean;
	errorMsg: string;
	wasChanged: boolean;
	servicesType: TRadioOpts;
	keyServices: Array<number>;
	origKeyServices: Array<number>;
	projectServices: Array<IServiceLittle>;
}

interface IKey {
	userTitle: string;
	userSwitch: boolean;
	userDescription: string;
	internalDescription: string;
	restrictions: IRestrictions;
}

// chyby formulare
type TStateErrors = {[key in keyof Pick<IKey, "userTitle" | "userDescription" | "internalDescription">]: string; };

interface ICreateKeyModal {
	isInternal: boolean;
	params: IUrlParams;
	keyData: IClientKey | IAdminKey;
	projectLastUpdate: string;
	projectServices: Array<IServiceLittle>;
	onSave?: (key: IClientKey | IAdminKey, projectLastUpdate: string) => void;
	onClose?: () => void;
	onChange?: (isChanged: boolean) => void;
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function CreateKeyModal({
	isInternal = false,
	params = null,
	keyData = null,
	projectLastUpdate = "",
	projectServices = [],
	onSave = () => {},
	onClose = () => {},
	onChange = () => {},
}: ICreateKeyModal) {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { setNotification } = notificationStore(notificationState => ({
		setNotification: notificationState.setNotification,
	}));
	const { state, updateState } = myUseState<IState>({
		mainLoad: false,
		dialogLoading: true,
		errorMsg: "",
		wasChanged: false,
		servicesType: "all",
		keyServices: [],
		origKeyServices: [],
		projectServices,
	});
	const { state: stateKey, updateState: updateStateKey } = myUseState<IKey>({
		userTitle: keyData.userTitle,
		userSwitch: keyData.userSwitch,
		userDescription: keyData.userDescription,
		internalDescription: "internalDescription" in keyData ? keyData.internalDescription : "",
		restrictions: keyData.restrictions,
	});
	const { state: stateError, setState: setStateError } = myUseState<TStateErrors>({
		userTitle: "",
		userDescription: "",
		internalDescription: "",
	});
	const isNew = keyData.id === 0;
	const title = isNew ? trans("createKey.titleNew") : trans("createKey.titleEdit");

	function getWasChanged(newState: Partial<IKey>): boolean {
		const newKeyState = {
			...stateKey,
			...newState,
		};
		const internalDescription = "internalDescription" in keyData ? keyData.internalDescription : "";

		if (
			newKeyState.userTitle !== keyData.userTitle
			|| newKeyState.userSwitch !== keyData.userSwitch
			|| newKeyState.userDescription !== keyData.userDescription
			|| newKeyState.internalDescription !== internalDescription
			|| JSON.stringify(newKeyState.restrictions) !== JSON.stringify(keyData.restrictions)
		) {
			return true;
		}

		return false;
	}

	function updateStateKeyWithChange(newState: Partial<IKey>, stateChanges?: Partial<IState>) {
		const wasChanged = getWasChanged(newState);
		const newStateChanges = {
			...state,
			...stateChanges,
			wasChanged,
		};

		if (!newStateChanges.wasChanged) {
			newStateChanges.wasChanged = (!compareArray(state.origKeyServices, newStateChanges.keyServices) && newStateChanges.servicesType === "selected")
				|| (newStateChanges.servicesType === "all" && state.origKeyServices.length > 0);
		}

		updateStateKey(newState);
		updateState(newStateChanges);
		onChange(wasChanged);
	}

	function keyCopy() {
		navigator.clipboard.writeText(keyData.apiKey);
		setNotification(trans("keyCopiedToClipboard"));
	}

	function onRestrictionsEditUpdate(restrictions: IRestrictions) {
		updateStateKeyWithChange({ restrictions });
	}

	async function dialogOnSave() {
		const errorData = checkForErrorsState<IKey, TStateErrors>(stateKey, {
			userTitle: { check: "string-2-35", msg: trans("createKey.error.userTitle") },
			userDescription: { check: "string-user-desc", msg: trans("createKey.error.userDescriptionCount", { count: MAX_USER_DESCIPTION_LEN }) },
			internalDescription: { check: "string-int-desc", msg: trans("createKey.error.internalDescriptionCount", { count: MAX_INT_DESCIPTION_LEN }) },
		});

		setStateError(errorData.errorsState);

		// jsou tam chyby
		if (errorData.errorsCount > 0) {
			return;
		}

		updateState({
			dialogLoading: true,
			errorMsg: "",
		});

		let outputData: IFetchOutput<IClientKey | IAdminKey> = null;

		const wholeData = {
			...stateKey,
			lastUpdate: projectLastUpdate,
		};

		if (isInternal) {
			if (isNew) {
				outputData = await apiCreateKey("admin", params.projectId, wholeData, lang);
			} else {
				outputData = await apiUpdateKey("admin", params.projectId, keyData.id, wholeData, lang);
			}
		} else {
			const { internalDescription, ...updateClientKeyData } = wholeData;

			if (isNew) {
				outputData = await apiCreateKey("client", params.projectId, updateClientKeyData, lang);
			} else {
				outputData = await apiUpdateKey("client", params.projectId, keyData.id, updateClientKeyData, lang);
			}
		}

		if (outputData.noErrors) {
			// poresime opravneni
			if (!compareArray(state.keyServices, state.origKeyServices) || (state.servicesType === "all" && state.origKeyServices.length > 0)) {
				const updateServicesData = await apiUpdateKeyServices(isInternal ? "admin" : "client", params.projectId, outputData.data.id, {
					services: state.servicesType === "all"
						? []
						: state.keyServices,
					lastUpdate: outputData.lastUpdate,
				}, lang);

				if (updateServicesData.noErrors) {
					onSave(outputData.data, updateServicesData.lastUpdate);
				} else {
					updateState({
						dialogLoading: false,
						errorMsg: updateServicesData.errors.join(", "),
					});
				}
			} else {
				onSave(outputData.data, outputData.lastUpdate);
			}
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: outputData.errors.join(", "),
			});
		}
	}

	async function loadData() {
		const newState: Partial<IState> = {
			mainLoad: true,
			dialogLoading: false,
		};

		if (!isNew) {
			const data = await apiGetApiKeyServices(isInternal ? "admin" : "client", params.projectId, keyData.id, lang);

			if (data.noErrors) {
				const ids = data.data.map(item => item.id);;

				newState.keyServices = ids;
				newState.origKeyServices = ids.slice();
				newState.servicesType = newState.keyServices.length > 0
					? "selected"
					: "all";
			}
		}

		updateState(newState);
	}

	function getAllServicesIds() {
		return state.projectServices.map(item => item.id);
	}

	function serviceIdToString(id: number) {
		const filtered = state.projectServices.filter(item => item.id === id);

		return filtered.length > 0
			? filtered[0].service
			: "";
	}

	useEffect(() => {
		loadData();
	}, []);

	return <MyDialog title={title} onClose={onClose} onSave={dialogOnSave} className="createKeyModal" dialogLoading={state.dialogLoading}
		disableSave={!state.wasChanged} confirmClose={state.wasChanged} errorMsg={state.errorMsg} saveCaption={isNew ? trans("createKey") : trans("saveChanges")}>
		{ state.mainLoad && <>
			{ !isNew && <div className="createKeyModal__apiKey">
				<span className="createKeyModal__apiKeyText">
					{ keyData.apiKey.slice(0, KEY_DETAIL_LENGTH) }...
				</span>
				<Button className="createKeyModal__apiKeyBtn" onClick={keyCopy}>
					<ContentCopyIcon />
				</Button>
			</div> }
			<FormControlLabel
				control={<MySwitch sx={{ m: 1 }} checked={stateKey.userSwitch} onChange={event => updateStateKeyWithChange({ userSwitch: event.target.checked })} />}
				label={trans("createKey.allowCall")}
				className="margin-bottom-large"
			/>
			<TextField
				label={trans("createKey.userTitle")}
				value={stateKey.userTitle}
				style={{ width: "100%" }}
				onChange={event => updateStateKeyWithChange({ userTitle: event.target.value })}
				color="success"
				autoComplete="off"
				error={stateError.userTitle !== ""}
				helperText={stateError.userTitle}
				sx={{ marginBottom: "25px" }}
				size="small"
			/>
			<TextField
				label={trans("createKey.userDescription")}
				value={stateKey.userDescription}
				style={{ width: "100%" }}
				multiline={true}
				onChange={event => updateStateKeyWithChange({ userDescription: event.target.value })}
				color="success"
				autoComplete="off"
				rows={3}
				sx={{ marginBottom: "25px" }}
				error={stateError.userDescription !== ""}
				helperText={stateError.userDescription}
			/>
			{ isInternal && <TextField
				label={trans("createKey.internalDescription")}
				value={stateKey.internalDescription}
				style={{ width: "100%" }}
				multiline={true}
				onChange={event => updateStateKeyWithChange({ internalDescription: event.target.value })}
				color="success"
				autoComplete="off"
				rows={3}
				sx={{ marginBottom: "25px" }}
				error={stateError.internalDescription !== ""}
				helperText={stateError.internalDescription}
			/> }
			<h2 style={{ marginTop: "0" }}>
				{ trans("createKey.servicesAccess") }
			</h2>
			<div className="createKeyModal__servicesType">
				<FormControl>
					<RadioGroup row value={state.servicesType} onChange={event => updateStateKeyWithChange({}, { servicesType: event.target.value as TRadioOpts })}>
						<FormControlLabel value={"all" as TRadioOpts} control={<Radio />} label={trans("createKey.servicesAccess.all")} />
						<FormControlLabel value={"selected" as TRadioOpts} control={<Radio />} label={trans("createKey.servicesAccess.selected")} />
					</RadioGroup>
				</FormControl>
			</div>
			{ (state.keyServices.length > 0 || state.servicesType === "selected") && <div>
				<Autocomplete
					multiple
					options={getAllServicesIds()}
					disableCloseOnSelect
					getOptionLabel={serviceIdToString}
					value={state.keyServices}
					onChange={(event, values: Array<number>) => updateStateKeyWithChange({}, { keyServices: values })}
					size="small"
					disabled={state.servicesType === "all"}
					renderOption={(props, option: number, data) => {
						const { key, ...rest } = props;
						const serviceData = state.projectServices.filter(projectService => projectService.id === option)[0];

						return <li key={option} {...rest}>
							<Checkbox
								icon={icon}
								checkedIcon={checkedIcon}
								style={{ marginRight: 8 }}
								checked={data.selected}
							/>
							<div style={{ display: "flex", gap: "3px", flexDirection: "column" }}>
								<div>{ serviceData.service }</div>
							</div>
						</li>;
					}}
					renderInput={renderParams => <TextField {...renderParams} label={trans("createKey.servicesAccess.activeTitle")} />}
					sx={{ background: "#fff", marginTop: "var(--margin-large)", marginBottom: "var(--margin-large)" }}
				/>
			</div> }
			<h2>
				{ trans("createKey.keyRestrictions") }
			</h2>
			<KeyRestrictionsEdit keyData={keyData} defaultType={getRestrictionType(keyData)} onUpdate={onRestrictionsEditUpdate} />
		</> }
	</MyDialog>;
}
